import { ModalHeader } from '@/components/Modal'

import { useMode } from '../../ContextProvider'
import { useTexts } from './useTexts'

export function Header() {
  const mode = useMode()
  const texts = useTexts()

  return <ModalHeader title={texts.header.title(mode)} />
}
